import { useParams } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { MapPin } from 'lucide-react';

export const PositionNotFoundPage = () => {
	const { positionId } = useParams<{ positionId: string }>();

	return (
		<div className="min-h-screen bg-blue-50 flex items-center justify-center px-4">
			<Card className="w-full max-w-md shadow-lg">
				<CardHeader className="text-center">
					<div className="mx-auto w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mb-4">
						<MapPin className="w-8 h-8 text-orange-600" />
					</div>
					<CardTitle className="text-2xl font-semibold text-gray-900">
						Position Not Found
					</CardTitle>
				</CardHeader>
				<CardContent className="text-center space-y-6">
					<div className="space-y-3">
						<p className="text-gray-600">
							{positionId ? (
								<>
									The position with ID "
									<code className="bg-gray-100 px-2 py-1 rounded text-sm font-mono">
										{positionId}
									</code>
									" could not be found.
								</>
							) : (
								"The position you're looking for could not be found."
							)}
						</p>
						<div className="text-sm text-gray-500 space-y-1">
							<p>This could happen if:</p>
							<ul className="text-left list-disc list-inside space-y-1 max-w-xs mx-auto">
								<li>The position ID is incorrect</li>
								<li>The position has been removed</li>
								<li>The link has expired</li>
							</ul>
						</div>
					</div>
				</CardContent>
			</Card>
		</div>
	);
};
